import React, { FC, useState, useEffect } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import Isvg from 'react-inlinesvg'
// Styles
import { H4 } from "styles/app-styles"
import { Container_s, Content_s } from "styles/app-styles"
import { ReportContainer_s, ReportForms_s, ReportSelection_s, ReportSelectionItem_s } from "styles/report-styles"
// Data
import folderService from "data/folder"
import propertyService from "data/property"
import socketService, * as eventType from "data/socket"
import { local } from 'data/lib/local-json'
// Components
import Subnav from "components/subnav"
// Commercial
import CommercialCashFlow from 'components/property/reports/commercial/cash-flow'
import ContractualTenantRevenue from "components/property/reports/commercial/contractual-tenant-revenue"
import Expiration from "components/property/reports/commercial/expiration"
import CommercialInputAssumptions from 'components/property/reports/commercial/input-assumptions'
import MarketLease from 'components/property/reports/commercial/market-lease-values'
import Occupancy from 'components/property/reports/commercial/occupancy'
import UnitOccupancy from 'components/property/reports/multifamily/unit-occupancy'
import OccupancyArea from "components/property/reports/commercial/occupany-area"
import RentRoll from "components/property/reports/commercial/rent-roll"
import RollOver from "components/property/reports/commercial/roll-over"
import Gvac from "components/property/reports/commercial/gvac"
import TenantCommercialCashFlow from "components/property/reports/commercial/tenant-cash-flow"
import FullTenantDetail from "components/property/reports/commercial/full-tenant-detail"
import PercentReimbursed from "components/property/reports/commercial/percent-reimbursed"
import PropertyComparison from "components/property/reports/commercial/property-comparison"
import MarketComparison from "components/property/reports/commercial/market-comparison"
import TenantPercentRentAudit from "components/property/reports/commercial/tenant-percent-rent-audit"
import TenantRoster from "components/property/reports/commercial/tenant-roster"
import TenantRosterComparison from "components/property/reports/commercial/tenant-roster-comparison"
import WALTReport from "components/property/reports/commercial/weighted-average-lease-term"
import RecoveryPoolAudit from "components/property/reports/commercial/recovery-pool-audit"
import RentRollRecovery from "components/property/reports/commercial/rent-roll-recovery"
import TenantDetailComparison from "./commercial/tenant-detail-comparison"
import TenantMarketComparison from "components/property/reports/commercial/tenant-market-comparison"
import TenantRecoveryAudit from "components/property/reports/commercial/tenant-recovery-audit"
import TenantRecoveryDetail from "components/property/reports/commercial/tenant-recovery-detail"
// MF
import MFCashFlow from 'components/property/reports/multifamily/cash-flow'
import MultifamilyInputAssumptions from 'components/property/reports/multifamily/input-assumptions'
import MFRentRoll from 'components/property/reports/multifamily/rent-roll'
import UnitDetail from 'components/property/reports/multifamily/unit-detail'
import Valuation from 'components/property/reports/multifamily/valuation'
import UnitCashFlow from 'components/property/reports/multifamily/unit-cash-flow'
// Hospitality
import HospitalityCashFlow from 'components/property/reports/hospitality/cash-flow'
import HospitalityInputAssumptions from 'components/property/reports/hospitality/input-assumptions'
import RoomDetail from 'components/property/reports/hospitality/room-detail'
import Rooms from 'components/property/reports/hospitality/rooms'
// Icons
import { PropertyIcon, RentRollIcon, RecoveriesIcon } from 'images/icons/sidebar/'
import { CompareArrowsIcon } from 'images/icons/general'

const MFPropertyReports: FC<RouteComponentProps> = () => {
  const [activeReport, setReport] = useState<string>('Property Cash Flow');
  const [isAMFolder, setAMFolder] = useState<boolean>(true);
  const [property, setProperty]   = useState<object|null>(null);
  const propertyType              = local('property_type', null);

  const reports = propertyType === 'Multifamily' ? [
    { name: 'Property Cash Flow', component: MFCashFlow },
    { name: 'Rent Roll', component: MFRentRoll },
    { name: 'Unit Cash Flow', component: UnitCashFlow },
    { name: 'Unit Detail', component: UnitDetail },
    { name: 'Unit Occupancy', component: UnitOccupancy },
    { name: 'Valuation', component: Valuation },
    { name: 'Input Assumptions', component: MultifamilyInputAssumptions },
  ] : propertyType === 'Hospitality' ? [
    { name: 'Property Cash Flow', component: HospitalityCashFlow },
    { name: 'Rooms', component: Rooms },
    { name: 'Rooms Detail', component: RoomDetail },
    { name: 'Valuation', component: Valuation },
    { name: 'Input Assumptions', component: HospitalityInputAssumptions },
  ] : [
    { name: 'Property Cash Flow', component: CommercialCashFlow },
    { name: 'Contractual Tenant Revenue', component: ContractualTenantRevenue },
    { name: 'Expiration', component: Expiration },
    { name: 'Input Assumptions', component: CommercialInputAssumptions },
    { name: 'Market Lease Values', component: MarketLease },
    { name: 'Occupancy', component: Occupancy },
    { name: 'Occupancy by Area Measure', component: OccupancyArea },
    { name: 'Rent Roll', component: RentRoll },
    { name: 'Roll Over', component: RollOver },
    { name: 'Vacancy & Credit Loss Audit', component: Gvac },
    { name: 'Valuation', component: Valuation },
    { name: 'Cash Flow Comparison', component: PropertyComparison },
    { name: 'Market Comparison', component: MarketComparison },
    { name: 'Tenant Detail Comparison', component: TenantDetailComparison },
    { name: 'Tenant Roster Comparison', component: TenantRosterComparison },
    { name: 'Tenant Cash Flow', component: TenantCommercialCashFlow },
    { name: 'Current Revenue vs. Market', component: TenantMarketComparison },
    { name: 'Full Tenant Detail', component: FullTenantDetail },
    { name: 'Tenant Percent Rent Audit', component: TenantPercentRentAudit },
    { name: 'Tenant Roster', component: TenantRoster },
    { name: 'Weighted Average Lease Term', component: WALTReport },
    { name: 'Percent Reimbursed', component: PercentReimbursed },
    { name: 'Recovery Pool Audit', component: RecoveryPoolAudit },
    { name: 'Rent Roll Recovery Input', component: RentRollRecovery },
    { name: 'Tenant Recovery Audit', component: TenantRecoveryAudit },
    { name: 'Tenant Recovery Detail', component: TenantRecoveryDetail }
  ]
  if (propertyType === 'Mixed-Use') reports.splice(21, 0, { name: 'Unit Cash Flow', component: UnitCashFlow }, { name: 'Unit Detail', component: UnitDetail })

  useEffect(() => {
    const socketSubscription = socketService.stream().subscribe(data => {
      switch(data.eventType) {
        case eventType.PROPERTY_SELECTED:
          if(data.event.propertyId){
            propertyService.fetchProperty(data.event.propertyId);
          }
          break;
      }
    })

    const propertySubscription = propertyService.stream().subscribe(data => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
    })

    const currentFolder = _.last(local('folderPath'))
    const folderSubscription = folderService.stream().subscribe((data) => {
      if (data.state == 'ok') {
        const folders = data.value
        const folder = _.find(folders, { folderid: currentFolder })
        if (!folder) return
        let parentFolder = _.find(folders, {folderid: folder.folderid}).parentfolder
        let isAssetManagementFolder = folder['code'] === '*AssetManagement'
        while (parentFolder) {
          const parent = _.find(folders, {folderid: parentFolder})
          if (parent && parent['code'] === '*AssetManagement') isAssetManagementFolder = true
          if (_.find(folders, {folderid: parent?.parentfolder})) parentFolder = _.find(folders, {folderid: parent?.parentfolder}).folderid
          else break
        } 
        isAssetManagementFolder ? setAMFolder(true) : setAMFolder(false)
      }
    })

    propertyService.fetchProperty(propertyService.getStoredPropertyId());

    return function cleanup() {
      folderSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      socketSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    setReport(reports?.[0]?.['name'])
  }, [propertyType])

  return (
    <Container_s>
      <Subnav section="REPORTS" tabs={[]}/>
      <Content_s>
        <ReportContainer_s>
          <ReportSelection_s>
            <H4>Reports</H4>
              { (propertyType === 'Commercial' || propertyType === 'Mixed-Use') ? (
                <ul>
                  <details open>
                    <summary>Property <Isvg src={PropertyIcon} /></summary>
                    { reports.slice(0, 11).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    ))}
                  </details>
                  <details open style={!isAMFolder ? {'display': 'none'} : {}}>
                    <summary className="property-comparison-summary">Property Comparison<Isvg src={PropertyIcon} /><Isvg src={CompareArrowsIcon} /><Isvg src={PropertyIcon} /></summary>
                    { reports.slice(11, 15).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    ))}
                  </details>
                  <details open>
                    <summary>Tenant <Isvg src={RentRollIcon} /></summary>
                    { propertyType === 'Mixed-Use' ? reports.slice(15, 23).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    )) : reports.slice(15, 21).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    ))}
                  </details>
                  <details open>
                    <summary>Recovery <Isvg src={RecoveriesIcon} /></summary>
                    { propertyType === 'Mixed-Use' ? reports.slice(23, 28).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    )) : reports.slice(21, 26).map((report) => (
                      <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                        {report.name}
                      </ReportSelectionItem_s>
                    ))}
                  </details>
                </ul>
                ) : (
                <ul>
                  { reports.map((report) => (
                    <ReportSelectionItem_s active={activeReport === report.name} onClick={()=>{setReport(report.name)}}>
                      {report.name}
                    </ReportSelectionItem_s>
                  ))}
                </ul>
              )}
          </ReportSelection_s>
          <ReportForms_s>
            { property && activeReport === 'Input Assumptions' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <CommercialInputAssumptions /> }
            { property && activeReport === 'Input Assumptions' && propertyType === 'Multifamily' && <MultifamilyInputAssumptions /> }
            { property && activeReport === 'Input Assumptions' && propertyType === 'Hospitality' && <HospitalityInputAssumptions /> }
            { property && activeReport === 'Property Cash Flow' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <CommercialCashFlow property={property} /> }
            { property && activeReport === 'Property Cash Flow' && propertyType === 'Multifamily' && <MFCashFlow property={property} /> }
            { property && activeReport === 'Property Cash Flow' && propertyType === 'Hospitality' && <HospitalityCashFlow property={property} /> }
            { property && activeReport === 'Contractual Tenant Revenue' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <ContractualTenantRevenue property={property} /> }
            { property && activeReport === 'Occupancy' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <Occupancy property={property} /> }
            { property && activeReport === 'Occupancy by Area Measure' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <OccupancyArea property={property} /> }
            { property && activeReport === 'Unit Occupancy' && propertyType === 'Multifamily' && <UnitOccupancy property={property} /> }
            { property && activeReport === 'Market Lease Values' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <MarketLease property={property} /> }
            { property && activeReport === 'Expiration' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <Expiration property={property} /> }
            { property && activeReport === 'Full Tenant Detail' && <FullTenantDetail property={property} /> }
            { property && activeReport === 'Rent Roll' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <RentRoll property={property} /> }
            { property && activeReport === 'Roll Over' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <RollOver property={property} /> }
            { property && activeReport === 'Vacancy & Credit Loss Audit' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <Gvac property={property} /> }
            { property && activeReport === 'Recovery Pool Audit' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <RecoveryPoolAudit property={property} /> }
            { property && activeReport === 'Current Revenue vs. Market' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <TenantMarketComparison property={property} /> }
            { property && activeReport === 'Market Comparison' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <MarketComparison property={property} /> }
            { property && activeReport === 'Percent Reimbursed' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <PercentReimbursed property={property} /> }
            { property && activeReport === 'Cash Flow Comparison' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <PropertyComparison property={property} /> }
            { property && activeReport === 'Tenant Detail Comparison' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <TenantDetailComparison property={property} /> }
            { property && activeReport === 'Tenant Roster Comparison' && (propertyType === 'Commercial' || propertyType === 'Mixed-Use') && <TenantRosterComparison property={property} /> }
            { property && activeReport === 'Rent Roll' && propertyType === 'Multifamily' && <MFRentRoll property={property} /> }
            { property && activeReport === 'Rent Roll Recovery Input' && <RentRollRecovery property={property} /> }
            { property && activeReport === 'Rooms' && <Rooms property={property} /> }
            { property && activeReport === 'Rooms Detail' && <RoomDetail property={property} /> }
            { property && activeReport === 'Tenant Cash Flow' && <TenantCommercialCashFlow property={property} /> }
            { property && activeReport === 'Tenant Percent Rent Audit' && <TenantPercentRentAudit property={property} /> }
            { property && activeReport === 'Tenant Recovery Audit' && <TenantRecoveryAudit property={property} /> }
            { property && activeReport === 'Tenant Recovery Detail' && <TenantRecoveryDetail property={property} /> }
            { property && activeReport === 'Tenant Roster' && <TenantRoster property={property} /> }
            { property && activeReport === 'Unit Cash Flow' && <UnitCashFlow property={property} /> }
            { property && activeReport === 'Unit Detail' && <UnitDetail property={property} /> }
            { property && activeReport === 'Valuation' && <Valuation property={property} /> }
            { property && activeReport === 'Weighted Average Lease Term' && <WALTReport property={property} /> }
          </ReportForms_s>
        </ReportContainer_s>
      </Content_s>
    </Container_s>
  )
}

export default MFPropertyReports

